import {AxiosResponse} from 'axios'
import {RawPersonTargetFeature} from '../types'
import {HttpInstance} from '../createHttpInstance'

interface Params {
  ClientID: number
  PersonID: number
  TargetPersonID: number
  FeatureID: number
  StartDate?: string | null
  EndDate?: string | null
}

export interface CreatePersonTargetFeature<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const createPersonTargetFeature: CreatePersonTargetFeature<
  Params,
  RawPersonTargetFeature
> = (http, params) => {
  try {
    return http.post<RawPersonTargetFeature>(
      '/v1/featuresettings/persontarget',
      params,
    )
  } catch (e) {
    if (e instanceof Error) {
      throw e
    } else {
      throw new Error(e as string)
    }
  }
}
